import classNames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { Tooltip } from '@eika/tooltip';

import { ComparisonTableMobileProps, RowProps } from './ComparisonTableTypes';

import './ComparisonTableMobile.scss';

export const ComparisonTableMobile = ({
    rows,
    tableHeadColumns,
    numberOfStarsBasedOnFootnotesIndex,
}: ComparisonTableMobileProps) => {
    const singleDekning = tableHeadColumns.length === 1;

    const tableLength = tableHeadColumns.length;
    const reversedPosition = (index) => tableLength - index - 1;

    const getDescription = (index: number) => {
        return rows.filter(
            (row: RowProps) =>
                reversedPosition(index) + 1 === row.checkedRows ||
                (row.subTexts && row.subTexts?.length > reversedPosition(index)),
        ) as RowProps[];
    };
    return (
        <div className={classNames('mobile-comparison-table__container')}>
            {tableHeadColumns.map((row, rowIndex) => (
                <div
                    className={classNames('mobile-comparison-table__card', {
                        [`mobile-comparison-table__card--${tableHeadColumns[reversedPosition(rowIndex)].color}`]:
                            tableHeadColumns[reversedPosition(rowIndex)].color,
                    })}
                    key={row.title + row.description}
                >
                    {!singleDekning && (
                        <div
                            className={classNames('mobile-comparison-table__header', {
                                'mobile-comparison-table__header--recommended':
                                    tableHeadColumns[reversedPosition(rowIndex)].recommendationLabel,
                            })}
                        >
                            {tableHeadColumns[reversedPosition(rowIndex)].recommendationLabel && (
                                <div className="mobile-comparison-table__recommendation-label">
                                    {tableHeadColumns[reversedPosition(rowIndex)].recommendationLabel}
                                </div>
                            )}
                            <div className={classNames('mobile-comparison-table__header-title')}>
                                {tableHeadColumns[reversedPosition(rowIndex)].title}
                                {tableHeadColumns[reversedPosition(rowIndex)].recommendationLabel && (
                                    <Icon
                                        wrapperClassName="mobile-comparison-table__recommendation-icon"
                                        type={IconTypes.STJERNEDRYSS_24}
                                    />
                                )}
                            </div>
                            <span className={classNames('mobile-comparison-table__header-description')}>
                                {tableHeadColumns[reversedPosition(rowIndex)]?.description}
                                {rowIndex >= 1 && tableHeadColumns[reversedPosition(rowIndex)]?.description
                                    ? '. '
                                    : undefined}
                                {rowIndex >= 1
                                    ? `Dekker det samme som ${
                                          tableHeadColumns[reversedPosition(rowIndex - 1)].title
                                      }, og i tillegg dette:`
                                    : ''}
                            </span>
                        </div>
                    )}
                    <div
                        className={classNames('mobile-comparison-table__content', {
                            'mobile-comparison-table__content--single-dekning': singleDekning,
                        })}
                    >
                        {getDescription(rowIndex).map((description: RowProps) => (
                            <p className="mobile-comparison-table__content-field" key={description.title}>
                                <Icon
                                    wrapperClassName="sgw-comparison-table__checkmark mobile-comparison-table__checkmark"
                                    type={IconTypes.CHECKMARK_TIL_SIRKEL_24}
                                />
                                <span>
                                    {description.title}
                                    {description.titleFootnote &&
                                        numberOfStarsBasedOnFootnotesIndex(description.titleFootnote)}
                                    {description.subTexts && (
                                        <>
                                            {`,\xa0`}
                                            <b>
                                                {
                                                    description.subTexts[
                                                        reversedPosition(rowIndex) % description.subTexts.length
                                                    ].text
                                                }
                                                {description.subTexts[
                                                    reversedPosition(rowIndex) % description.subTexts.length
                                                ].footnote &&
                                                    numberOfStarsBasedOnFootnotesIndex(
                                                        description.subTexts[
                                                            reversedPosition(rowIndex) % description.subTexts.length
                                                        ].footnote,
                                                    )}
                                            </b>
                                        </>
                                    )}
                                </span>
                                {description.help && <Tooltip title={description.title}>{description.help}</Tooltip>}
                            </p>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
